import React from 'react';

export default function Skeleton({ active, children }) {
    return (
        active ?
            <div style={{
                width: '8em',
                display: 'block',
                backgroundColor: 'rgba(0, 0, 0, 0.11)',
                height: 20,
                marginTop: '0',
                marginBottom: '0',
                transformOrigin: '0 55%',
                WebkitTransform: 'scale(1, 0.60)',
                MozTransform: 'scale(1, 0.60)',
                MsTransform: 'scale(1, 0.60)',
                transform: 'scale(1, 0.60)',
                borderRadius: 4,
            }} />
            : children
    )
}